interface FeatureColumnData {
  items: string[];
}

interface FeatureColumnProps {
  column: FeatureColumnData;
}

export function FeatureColumn({ column }: FeatureColumnProps) {
  return (
    <div className="square">
      <ul>
        {column.items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

export type { FeatureColumnData };
